import { Controller } from "@hotwired/stimulus";
import { Swiper } from "swiper";
import { Autoplay, Pagination } from "swiper/modules";

export default class Carousel extends Controller {
  connect() {
    this.swiper = new Swiper(this.element, {
      modules: [Pagination, Autoplay],
      pagination: {
        el: ".swiper-pagination",
        type: "bullets",
        enabled: true,
        clickable: true,
      },
      autoplay: {
        enabled: true,
        delay: 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
    });
  }

  disconnect() {
    this.swiper.destroy();
    this.swiper = undefined;
  }
}
